import ICompanyReducer from "../interfaces/ICompanyReducer";
import {
  ADD_NOTIFICATION,
  ALL_DATA_SAVED,
  GET_COMPANY_INFO,
  GET_COMPANY_INVESTORS,
  GET_COMPANY_MEMBERS,
  GET_COMPANY_TOP_INVESTORS,
  GET_DOCUMENTS_INFO,
  GET_FUNDING_DATA,
  REMOVE_NOTIFICATION,
  RESET_LOCAL_STATE,
  RESTORE_LOCAL_STATE,
  SAVE_ALL_DATA,
  SET_FORM_DIRTY,
  SET_IS_SAVING,
  SET_USER_SIGNED_IN,
  UPDATE_COMPANY_FOLLOWERS,
  UPDATE_COMPONENTS_COUNTER,
  UPDATE_VALIDATION_COUNTER,
} from "./actionTypes";
import CompaniesPageMockService from "@mocks/CompaniesPage.mock.service";
import noPhotoMaleBig from "@images/no_photo_male_big.png";

const initialState: ICompanyReducer = {
  companyDetails: CompaniesPageMockService.getCompanyReducer(),
  companyInvestors: null,
  companyTopInvestors: null,
  cover_photo: {
    id: "",
    url: "",
  },
  companyMembers: null,
  documents: [],
  editMode: false,
  isSaving: false,
  formDirty: false,
  validationCounter: 0,
  componentCounter: 0,
  notificationsList: [],
  funding: [],
  newFunding: {},
  userData: {
    avatar: noPhotoMaleBig,
    profileId: null,
    country: null,
    investorId: null,
    _2fa_enabled: undefined,
    can_withdraw: undefined,
    investor_kyc: undefined,
    usdWithdrawalEnabled: undefined,
    isOrganizational: undefined,
    has_investments: undefined,
  },
  userSignedIn: false,
  isOrganizational: false,
};

let pastState: ICompanyReducer = initialState;
let localState: ICompanyReducer = initialState;

function reducer(
  state: ICompanyReducer = localState,
  action: any
): ICompanyReducer {
  const notificationsList = Array.from(state.notificationsList);

  switch (action.type) {
    case SAVE_ALL_DATA:
      if (action.name === "funding") {
        localState = {
          ...state,
          funding: [...action.payload.funding],
          companyDetails: {
            ...state.companyDetails,
            funding_to_date: [...action.payload.fundingToDate],
          },
          isSaving: false,
        };
        break;
      }

      localState = {
        ...state,
        [action.name]: Array.isArray(action.payload)
          ? [...action.payload]
          : { ...action.payload },
        isSaving: false,
      };
      break;

    case ALL_DATA_SAVED:
      localState = {
        ...state,
        funding: action.payload.investment_rounds,
        companyInvestors: { ...action.payload.company_investors },
        companyMembers: { ...action.payload.company_members },
        validationCounter: 0,
        formDirty: false,
      };
      break;

    case SET_IS_SAVING:
      localState = { ...state, isSaving: true };
      break;

    case SET_FORM_DIRTY:
      localState = { ...state, formDirty: action.payload };
      break;

    case UPDATE_COMPONENTS_COUNTER:
      localState = {
        ...state,
        componentCounter: state.componentCounter + action.payload,
        formDirty: false,
      };
      break;

    case ADD_NOTIFICATION:
      notificationsList.push(action.payload);
      localState = { ...state, notificationsList };
      break;

    case REMOVE_NOTIFICATION:
      notificationsList.splice(action.payload, 1);
      localState = { ...state, notificationsList };
      break;

    case UPDATE_VALIDATION_COUNTER:
      localState = {
        ...state,
        validationCounter: state.validationCounter + action.payload,
      };
      break;

    case GET_COMPANY_INVESTORS:
      localState = { ...state, companyInvestors: { ...action.payload } };
      break;

    case GET_COMPANY_TOP_INVESTORS:
      localState = { ...state, companyTopInvestors: { ...action.payload } };
      break;

    case GET_COMPANY_MEMBERS:
      localState = { ...state, companyMembers: { ...action.payload } };
      break;

    case GET_COMPANY_INFO:
      localState = {
        ...state,
        companyDetails: action.payload,
        cover_photo: action.payload.cover_photo,
      };
      break;

    case GET_DOCUMENTS_INFO:
      localState = { ...state, documents: action.payload };
      break;

    case GET_FUNDING_DATA:
      localState = { ...state, funding: action.payload };
      break;

    case RESET_LOCAL_STATE:
      pastState = { ...state };
      localState = { ...initialState };
      break;

    case RESTORE_LOCAL_STATE:
      localState = { ...pastState, formDirty: false };
      break;

    case SET_USER_SIGNED_IN:
      localState = { ...pastState, userSignedIn: action.payload };
      break;

    case UPDATE_COMPANY_FOLLOWERS:
      localState = {
        ...state,
        companyDetails: {
          ...state.companyDetails,
          total_followers: action.payload,
        },
      };
      break;

    default:
      localState = { ...state };
  }

  return localState;
}

export default reducer;
